(function () {
    "use strict";

    angular.module("sod.helper").directive("dropdownSelectSearchable", dropdownSelectSearchable);

    const template = `<div class="dropdown-select-searchable-wrapper" id="<%elementId%>">
        <input
            type="text"
            ng-model="current"
            class="dropdown-select-searchable-selector mb-0 text-sm" 
            ng-click="showDropdown()"
            ng-keydown="handleKeyDown($event)"
        >
        <div class="dropdown-select-searchable-options-wrapper">
            <ul class="dropdown-select-searchable-options" ng-style="selectOptionsStyle" ng-class="{active: dropdownActive}">
                <li ng-class="{'highlighted': $index === selectedIndex} " class="dropdown-select-searchable-item" ng-repeat="option in filterOptions()" ng-bind-html="option.label" ng-click="select(option)" ng-mouseenter="highlightOptionWithMouse($index)"></li>
            </ul>
        </div>
    </div>`;
    function dropdownSelectSearchable(lodash, $document) {
        return {
            restrict: "E",
            require: "ngModel",
            template: template,
            scope: {
                options: "=",
            },
            link: function (scope, elem, attr, ctrl) {
                scope.dropdownActive = false;
                scope.elementId = scope.$id;
                scope.selectOptionsStyle = {};
                scope.previousValue = '';
                scope.selectedIndex = 0;
                var showAllFilters = true;
            
                var height = 0;
                for (var i = 0; scope.options.length > i; i++) {
                    height += 25;
                }
            
                ctrl.$render = function () {
                    const selected = lodash.find(scope.options, {
                        value: ctrl.$viewValue,
                    });
                    scope.current = selected ? selected.label : "";
                    scope.previousValue = scope.current;
                };
            
                scope.filterOptions = function () {
                    if(showAllFilters){
                        return scope.options.filter(function (option) {
                            return option.label
                                .toLowerCase()
                                .includes(scope.current.toLowerCase());
                        });
                    }
                    return scope.options;
                };
            
                scope.select = function (option) {
                    ctrl.$setViewValue(option.value);
                    scope.current = option.label;
                    scope.previousValue = option.label;
                    scope.dropdownActive = false;
                };
            
                scope.showDropdown = function () {
                    if(scope.current){
                        scope.previousValue = scope.current;
                        const indexes       = scope.options.map((opt, index) => opt.label === scope.current ? index : -1);
                        scope.selectedIndex = indexes.find(index => index !== -1);
                    }
                    showAllFilters = false;
                    scope.dropdownActive = true;
                    scope.selectOptionsStyle.height = height + 1;

                    var inputElem   = elem[0].querySelector('.dropdown-select-searchable-selector');
                    var offWidth    = inputElem.offsetWidth
                    scope.selectOptionsStyle.width = offWidth + 'px';

                    var optionList = elem[0].querySelector('.dropdown-select-searchable-options');
                    var highlightedOption = optionList.children[scope.selectedIndex];

                    if (highlightedOption) {
                        var optionListHeight = optionList.clientHeight;
                        var optionHeight = highlightedOption.clientHeight;

                        var highlightedTop = highlightedOption.offsetTop;
                        var highlightedBottom = highlightedTop + optionHeight;

                        if (highlightedBottom > optionList.scrollTop + optionListHeight) {
                            optionList.scrollTop = highlightedBottom - optionListHeight;
                        } else if (highlightedTop < optionList.scrollTop) {
                            optionList.scrollTop = highlightedTop;
                        }
                    }
                };
            
                scope.resetCurrent = function () {
                    if (!scope.current) {
                        scope.current = scope.previousValue;
                    }else{
                        const selected = lodash.find(scope.options, {
                            label: scope.current,
                        });
                        scope.current = selected ? selected.label : scope.previousValue;
                        scope.previousValue = scope.previousValue;
                    }
                };
            
                scope.isSelected = function (option) {
                    return option.label === scope.previousValue;
                };

                scope.highlightOption = function(key) {
                    var filteredOptions = scope.filterOptions();
                    var selectedIndex   = scope.selectedIndex <= filteredOptions.length ? scope.selectedIndex : -1;
                
                    if (key === "ArrowDown") {
                        selectedIndex = (selectedIndex == (filteredOptions.length - 1)) ? 0 : selectedIndex + 1;
                    } else if (key === "ArrowUp") {
                        selectedIndex = (selectedIndex == 0) ? filteredOptions.length - 1 : selectedIndex - 1;
                    }
                
                    scope.selectedIndex = selectedIndex;

                    var optionList = elem[0].querySelector('.dropdown-select-searchable-options');
                    var previouslyHighlightedOption = optionList.querySelector('.highlighted');
                    if (previouslyHighlightedOption) {
                        previouslyHighlightedOption.classList.remove('highlighted');
                    }   
                
                    var highlightedOption = optionList.children[selectedIndex];
                    if (highlightedOption) {
                        highlightedOption.classList.add('highlighted');
                    }
                
                    if (highlightedOption) {
                        var optionListHeight = optionList.clientHeight;
                        var optionHeight = highlightedOption.clientHeight;
                
                        var highlightedTop = highlightedOption.offsetTop;
                        var highlightedBottom = highlightedTop + optionHeight;
                
                        if (highlightedBottom > optionList.scrollTop + optionListHeight) {
                            optionList.scrollTop = highlightedBottom - optionListHeight;
                        } else if (highlightedTop < optionList.scrollTop) {
                            optionList.scrollTop = highlightedTop;
                        }
                    }
                
                    scope.$apply();
                };
            
            
                scope.handleKeyDown = _.debounce(function (event) {
                    var filteredOptions = scope.filterOptions();
                    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
                        event.preventDefault();
                        scope.highlightOption(event.key);
                    } else if (event.key === "Enter") {
                        event.preventDefault();
                        if (scope.selectedIndex >= 0 && scope.selectedIndex < filteredOptions.length) {
                            scope.select(filteredOptions[scope.selectedIndex]);
                        }
                    } else if (event.key === "Backspace") {
                        scope.current = '';
                        showAllFilters = true;
                    }
                    scope.$apply();
                }, 100);
                

                elem.on("keydown", scope.handleKeyDown);

                $document.on("click", function (e) {
                    if (
                        angular
                            .element(e.target)
                            .parents(".dropdown-select-searchable-wrapper").length === 0
                    ) {
                        scope.dropdownActive = false;
                        scope.resetCurrent();
                        scope.$apply();
                        return;
                    }
                    if (
                        angular
                            .element(e.target)
                            .parents(".dropdown-select-searchable-wrapper")
                            .attr("id") !== scope.elementId.toString()
                    ) {
                        scope.dropdownActive = false;
                        scope.resetCurrent();
                        scope.$apply();
                    }
                });

                scope.highlightOptionWithMouse = function(index) {
                    scope.selectedIndex = index;
                    scope.$apply();
                };
            
                scope.$on('$destroy', function() {
                    elem.off("keydown", scope.handleKeyDown);
                    $document.off("click");
                });
            },            
        };
    }
})();
